const ALERT_TYPES = {
    PMF_UPLOAD_FAILED: 'UPLOAD FAILED',
    PMF_EMBED_FAILED: 'EMBED FAILED',
    CHANGE_REQUEST_APPROVED: 'CHANGE_REQUEST_APPROVED',
    CHANGE_REQUEST_REJECTED: 'CHANGE_REQUEST_REJECTED',
    SWITCHED_TO_FALLBACK_MODE: 'SWITCHED_TO_FALLBACK_MODE',
}

export { ALERT_TYPES }
